/* eslint-disable no-nested-ternary */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Header from '../../components/Header';
import SubNav from '../../components/SubNav';
import Footer from '../../components/Footer';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import styles from './index.css';
import ToTop from '@ifeng-fe/container_channel/common/client/components/toTop';
import MainBox from './components/MainBox';
import Chip from 'Chip';
import NoSSR from 'react-no-ssr';
import Ad from '@ifeng-fe/ui_pc_ad';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { tabAd1, pageBottomAd } = content;
        const mainBoxAd = {
            tabAd1,
        };

        // 头部
        const headerData = {
            nav: { ...content.nav, limit: 17 },
            topAd: content.topAd,
            search: content.search,
            logo: content.logo,
        };

        // 底部
        const footerData = {
            footerNav: content.footerNav,
            footerCopyright: content.footerCopyright,
        };

        return (
            <div className={styles.pageBox}>
                <div className={styles.headerWrap}>
                    <Header content={headerData} />
                </div>
                <Chip id="230203" type="struct" title="凤凰卫视-首页子导航" groupName="正文" content={content.subNav}>
                    <SubNav theme={styles.subNav} active={content.paramName} />
                </Chip>
                <Chip id="260081" type="struct" title="凤凰卫视-栏目" groupName="正文" content={content.column}>
                    <MainBox adContent={mainBoxAd} />
                </Chip>
                <div className={styles.footerWrap}>
                    <NoSSR onSSR={<div className={styles.box} />}>
                        <Ad content={pageBottomAd} />
                    </NoSSR>
                    <Footer content={footerData} />
                </div>
                <ToTop windowMode="normal" />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
